import { render, staticRenderFns } from "./examBlock.vue?vue&type=template&id=fd5a2002&scoped=true"
import script from "./examBlock.vue?vue&type=script&lang=js"
export * from "./examBlock.vue?vue&type=script&lang=js"
import style0 from "./examBlock.vue?vue&type=style&index=0&id=fd5a2002&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5a2002",
  null
  
)

export default component.exports